import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=718210f0&scoped=true"
import script from "./CreateOrder.vue?vue&type=script&lang=js"
export * from "./CreateOrder.vue?vue&type=script&lang=js"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&id=718210f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718210f0",
  null
  
)

export default component.exports